var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 11.6665H9.99999C9.11593 11.6665 8.26809 12.0177 7.64297 12.6428C7.01785 13.2679 6.66666 14.1158 6.66666 14.9998V29.9998C6.66666 30.8839 7.01785 31.7317 7.64297 32.3569C8.26809 32.982 9.11593 33.3332 9.99999 33.3332H25C25.884 33.3332 26.7319 32.982 27.357 32.3569C27.9821 31.7317 28.3333 30.8839 28.3333 29.9998V28.3332",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 8.33327L31.6667 13.3333M33.975 10.9749C34.6314 10.3185 35.0002 9.42824 35.0002 8.49993C35.0002 7.57163 34.6314 6.68134 33.975 6.02493C33.3186 5.36852 32.4283 4.99976 31.5 4.99976C30.5717 4.99976 29.6814 5.36852 29.025 6.02493L15 19.9999V24.9999H20L33.975 10.9749Z",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerEdit);
export default __webpack_public_path__ + "static/media/tabler_edit.b37804b7bc4c3b5f49e308d22acfa88b.svg";
export { ForwardRef as ReactComponent };